import { Form } from '@/common/components/ui/form.tsx'
import { FieldErrors, FieldValues, UseFormHandleSubmit, UseFormReturn } from 'react-hook-form'
import { ClassValue } from 'clsx'
import React from 'react'
import { cn } from '@/utils/style.ts'
import { Spinner } from '@/common/components/Spinner.tsx'
import { FormSectionRootProvider } from '@/common/components/Form/useFormSection.tsx'
import { toast } from '@/common/components/ui/use-toast.ts'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormWrapperProps<TFieldValues extends FieldValues> = {
  className?: ClassValue
  isLoading?: boolean
  form: UseFormReturn<TFieldValues>
  onSubmit: Parameters<UseFormHandleSubmit<TFieldValues>>[0]
  onInvalid?: Parameters<UseFormHandleSubmit<TFieldValues>>[1]
  helpButtons?: React.ReactNode
} & {
  children: React.ReactNode
}

export const FormWrapper = <TFieldValues extends FieldValues, >({
  className,
  isLoading,
  form,
  onSubmit,
  onInvalid,
  helpButtons,
  children,
}: FormWrapperProps<TFieldValues>): React.ReactNode => {
  const onError = (e: FieldErrors<TFieldValues>) => {
    console.log(e)
    toast({ title: 'Form validation failed.', description: 'Please check the input again.', variant: 'destructive' })
    onInvalid?.(e)
  }

  return (
    <FormSectionRootProvider>
      <Form {...form}>
        {helpButtons}
        <form
          onSubmit={form.handleSubmit(onSubmit, onError)}
          className={cn('w-fit space-y-4', className)}
        >
          {children}
        </form>
        {
          isLoading &&
          <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-60 flex items-center justify-center z-10">
            <Spinner />
          </div>
        }
      </Form>
    </FormSectionRootProvider>
  )
}